

































import Vue from 'vue';
import store from '../store';
import {Question} from '../store';

interface Button {
  label: number;
  ok: boolean;
  ng: boolean;
}

export default Vue.extend({
  name: 'Solve',
  data: () => ({
    buttons: [
      { label: 1, ok: false, ng: false },
      { label: 2, ok: false, ng: false },
      { label: 3, ok: false, ng: false },
      { label: 4, ok: false, ng: false },
      { label: 5, ok: false, ng: false },
      { label: 6, ok: false, ng: false },
      { label: 7, ok: false, ng: false },
      { label: 8, ok: false, ng: false },
      { label: 9, ok: false, ng: false },
      { label: 10, ok: false, ng: false },
    ] as Button[],
    inputValue: 0,
    showQuestionMark: true,
  }),

  computed: {
    category: () => store.selectedCategory,
    isMultiple: () => store.selectedCategory != null && store.selectedCategory.id === 'mul1',
  },

  mounted() {
    this.newQuiz();
  },

  methods: {
    showPage: (name: string) => store.showPage(name),

    initButtons() {
      if (this.category === null) { throw new Error('category is null'); }
      const over10 = (this.category.id === 'add2' ? 11 : 1);

      for (let i = 0; i < this.buttons.length; i++) {
        this.buttons[i].label = i + over10;
        if (this.isMultiple) { this.buttons[9].label = 0; }
        this.buttons[i].ok = false;
        this.buttons[i].ng = false;
      }
      this.showQuestionMark = true;
      this.inputValue = 0;
    },

    newQuiz() {
      if (this.category === null) { throw new Error('category is null'); }

      this.initButtons();

      this.category.q = this.findQuestion();
      if (this.category.q === null) {
        return;
      }

      this.category.qStart = new Date();
    },

    clear() {
      this.inputValue = 0;
      this.showQuestionMark = true;
    },

    retry() {
      const category = this.category;
      if (category === null) { throw new Error('category is null'); }
      category.left = [...category.questions];
      category.timeCurrent = 0;
      this.newQuiz();
    },

    answer(btn: Button) {
      const category = this.category;
      if (category === null) { throw new Error('category is null'); }
      const q = category.q;
      if (q === null) { throw new Error('question is null'); }
      if (!this.isMultiple && (btn.ok || btn.ng)) { return; }

      const clicked = this.inputValue * 10 + btn.label;
      const ans = q.ans;

      if (this.isMultiple) {
        this.inputValue = clicked;
        if (ans >= 10 && clicked < 10) {
          return;
        }
        this.showQuestionMark = false;
      }

      if (ans !== clicked) {
        category.failed.push(new Question(q.lhs, q.rhs, clicked));
        btn.ng = !this.isMultiple;
        category.isNG = true;
        setTimeout(() => {
          this.inputValue = 0;
          this.showQuestionMark = true;
          category.isNG = false;
        }, 500);
      } else {
        category.solved++;
        const elapsed = new Date().getTime() - category.qStart.getTime();
        category.time += elapsed;
        category.timeCurrent += elapsed;
        const all = category.left;
        all.splice(all.indexOf(q), 1);

        btn.ok = true;
        category.isOK = true;
        setTimeout(() => {
          category.isOK = false;
          category.done++;
          this.newQuiz();
        }, 500);
      }
    },

    findQuestion() {
      if (this.category === null) { throw new Error('category is null'); }
      const all = this.category.left;
      if (all.length === 0) {
        return null;
      }

      return all[Math.floor(Math.random() * all.length)];
    },
  },
});
